var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Calendar',{attrs:{"v-if":_vm.info.length >= 0,"info":_vm.info},on:{"month-change":_vm.getData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }